'use client';

import type { PortableTextBlock } from 'next-sanity';
import './faqSection.scss';

import FaqAccordion from '@/componentv2/FaqAccordion/FaqAccordion';
import type { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';

type LandingPageData = Extract<
  NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>,
  { _type: 'landingPage' }
>;

interface FaqSectionProps {
  data: NonNullable<LandingPageData['faq']>;
}

export default function FaqSection({ data }: FaqSectionProps) {
  const { sectionLabel, faqs } = data;

  const items = (faqs || [])
    .filter((faq) => faq.question)
    .map((faq) => ({
      question: faq.question as string,
      answerBlocks: faq.answer as PortableTextBlock[] | undefined,
    }));

  if (items.length === 0) return null;

  return <FaqAccordion header={sectionLabel || ''} items={items} />;
}
